import {
  resolvers as creditCardResolvers,
  selectCard,
} from '../credit_cards/selectable_credit_card_list_query';
import { DocumentNode } from 'graphql';

import * as Document from '../schemas/local.gql';

// resolver functions return default values for locally extended types
// (ex: creditCard.isSelected is a client-side cached value, its default value
// is determined by its resolver function)
export const resolvers = {
  ...creditCardResolvers,
  Mutation: {
    selectCard,
  },
};

// type definitions for mutations, mutation queries,
// and extended types used for local caching
export const typeDefs: DocumentNode = {
  ...Document,
};



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/lib/local_apollo_schema.ts